import { GetRequestOptions } from "./grunt";

const getPth=process.env.REACT_APP_GRUNT_API+"/govedo/knjiga";
const GovedoByIdPth=process.env.REACT_APP_GRUNT_API+"/govedo/govedobyid";
///govedobyid/:govedoid

const StatusOk={status:200};

const updateGovedo=async ({govedo})=>{
    const _pth=`${GovedoByIdPth}/${govedo.govedo_id}`;
    try {
        let _reqopt = GetRequestOptions("PUT");
        _reqopt.body=JSON.stringify({
            zivbr:govedo.zivbr.toUpperCase(),
            mzivbr:govedo.mzivbr.toUpperCase(),
            ozivbr:govedo.ozivbr.toUpperCase(),
            datum_rodjenje:govedo.datum_rodjenje,
            spol:govedo.spol,
            pasmina_sifra:govedo.pasmina_sifra,
            rfid:govedo.rfid,
            ime:govedo.govedo_ime.toUpperCase(),
            putnica_oznaka:govedo.putnica_oznaka,
            putnica_serbr:govedo.putnica_serbr
        })
        /*
        datum_rodjenje:'2022-03-25'
        govedo_id:489
        govedo_ime:'UI'
        mzivbr:'CZ 227927941'
        ozivbr:'KJKJJKJKJK'
        pasmina_naziv:'OSTALI KRIŽANCI'
        pasmina_sifra:'03'
        putnica_oznaka:15137
        rfid:'78788787'
        spol:'f'
        zivbr:'CZ 000249395941'
             body("zivbr").matches(/^[A-Z]{2}\s\d{6,18}$/).withMessage("Neispravan format životnog broja goveda"),
    body("mzivbr").matches(/(^$|^[A-Z]{2}\s\d{6,18}$)/).withMessage("Neispravan format životnog broja majke"),
    body("ozivbr").matches(/(^$|^[A-Z]{2}\s\d{6,18}$)/).withMessage("Neispravan format životnog broja oca"),
    body("datum_rodjenje").isDate().withMessage("[datum rođenja] nije u ispravnom formatu."),
    body("spol").isIn(["m","f"]).withMessage("Spol goveda nema ispravnu oznaku."),
    body("pasmina_sifra").matches(/^\d{2}$/).withMessage("Neispravna šifra pasmine goveda."),
    body("rfid").isLength({min:0,max:20}).withMessage("RFID može biti maksimalne dužine 20 znakova."),
    body("ime").isLength({min:0,max:20}).withMessage("Ime može biti maksimalne dužine 20 znakova."),
    body("putnica_oznaka").isLength({min:0,max:9}).isInt().withMessage("Ime može biti maksimalne dužine 20 znakova.")
        */
        const r = await fetch(_pth, _reqopt);    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ažuriranja podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getGovedaNaFarmi=async ({knjigaid})=>{
    const _pth=`${getPth}/${knjigaid}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getGovedaUBoksu=async (_boksid)=>{
    const _pth=`${process.env.REACT_APP_GRUNT_API}/govedo/odjeljak/${_boksid}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
const getGovedaByOmigracijaId=async ({knjigaid,omigracijaid})=>{
    const _pth=`${getPth}/${knjigaid}/omigracija/${omigracijaid}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getGovedaBeforeOmigracijaId=async ({knjigaid,omigracijaid})=>{
    const _pth=`${getPth}/${knjigaid}/beforeomigracija/${omigracijaid}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}


const getGovedoById=async(_govedoid)=>{
    const _pth=`${GovedoByIdPth}/${_govedoid}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getGovedoById02=async(_govedoid)=>{
    const _pth=process.env.REACT_APP_GRUNT_API+"/govedo/govedo/"+_govedoid.toString();
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

export {getGovedaNaFarmi,getGovedaByOmigracijaId,getGovedaBeforeOmigracijaId,getGovedoById,updateGovedo,getGovedoById02,getGovedaUBoksu};